export default {
  data() {
    return {
      workZoneOptions: [],
      hideWorkZoneFilter: true
    }
  },
  computed: {
    workZoneId() {
      return this.$store.state.workzone.workZoneId
    },
    workZone() {
      return this.$store.state.workzone.workZone
    }
  },
  methods: {
    async handleWorkZoneSearchData(table, type = 'Store') {
      if (!table || !table.searchData || !table.searchData.length) {
        return
      }
      let workZoneIdx = table.searchData.findIndex(e => e.key === 'WorkZone')
      if (workZoneIdx < 0) {
        return
      }
      console.log(this.workZone, "59865")
      if (this.workZone !== 'ALL') {
        this.$set(table.searchData[workZoneIdx], 'hide', true)
        this.showWorkZoneFilter = true
        return
      }
      let res = await this.$store.dispatch({
        type: 'workzone/getWorkingZoneByType',
        data: type
      })
      this.workZoneOptions = (res || [])
        .filter(e => e.workingZone !== 'ALL')
        .map(t => {
          return {
            label: `${t.workingZone}-${t.name}`,
            value: t.workingZone
          }
        })
      this.showWorkZoneFilter = false
      this.$set(table.searchData[workZoneIdx], 'hide', false)
      this.$set(table.searchData[workZoneIdx], 'option', this.workZoneOptions)
    }
  }
}
